import type { TreeNode } from 'tree-model';

import type { TreeReducerModel } from '../../ducks/tree/types';

export const shouldLoadMore = (node: TreeNode<TreeReducerModel>): boolean => {
  const path = node.getPath();
  const parentNode = path[path.length - 2];
  if (!parentNode) {
    return false;
  }
  const { page = 1, pages = 1 } = parentNode.model;
  const isAllLoaded = pages <= page;
  const isLast = parentNode.children.length === node.getIndex() + 1;
  const value = !isAllLoaded && isLast;
  return value;
};
